import { useEffect } from 'react';
import { motion } from 'framer-motion';
function Promo() {
useEffect(() => {
document.title = "Fotograf na imprezy - Maciej Głąb"})
return (
<motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1, transition: { duration: 2 } }}
    exit={{ opacity: 0 }}
>

</motion.div>
);
}

export default Promo;
